import { PortfolioDto } from "../../../screens/portfolio-info/types/PortfolioDto";
import { createAuthenticatedApiClient } from "./AuthenticatedApiClient";

type ApiClient = ReturnType<typeof createAuthenticatedApiClient>;

export function createUnderlyingAssetPortfolioApi(apiClient: ApiClient) {
    const getByUnderlyingAsset = async (
        underlyingAssetId: number,
        portfolioGroupId?: number,
        includeContent?: boolean,
    ): Promise<PortfolioDto[] | null> => {
        try {
            const params = {
                ...(portfolioGroupId !== undefined ? { portfolioGroupId } : {}),
                ...(includeContent !== undefined ? { includeContent } : {}),
            };

            const response = await apiClient.get<PortfolioDto[]>(
                `/api/underlying-assets/${underlyingAssetId}/portfolios`,
                { params },
            );

            return response?.data ?? null;
        } catch (error: any) {
            console.log(error);
            return null;
        }
    };

    return {
        getByUnderlyingAsset,
    };
}
